export default "__VITE_ASSET__DVd_MpTC__"